// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".paymob-card-payment {\r\n    max-width: 900px;\r\n    width: 800px;\r\n    height: 800px;\r\n}\r\n", "",{"version":3,"sources":["webpack://src/component/CheckoutPayments/styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".paymob-card-payment {\r\n    max-width: 900px;\r\n    width: 800px;\r\n    height: 800px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
